'use strict';
Vue.mixin({
    data: function () {
        return {
            productId: ''
        };
    },
    mounted() {
        this.createOrderFormSend();
        this.frameNumberToUpperCase();
    },
    methods: {
        frameNumberToUpperCase: function () {
            $('input[name="frame_number"]').on('input', function () {
                $(this).val($(this).val().toUpperCase());
            });
        },
        createOrderFormSend: function () {
            var $form = $('form#create-order-form');
            var $this = this;

            $form.on('submit', function (e) {
                e.preventDefault();

                if ($form.parsley().isValid()) {
                    $.ajax({
                        method: 'POST',
                        url: $form.attr('action'),
                        data: $form.serialize(),
                        success: function ($resp) {
                            if ($resp.status) {
                                $this.showGeneralModule(
                                    $resp.data.modalHtml,
                                    function (e) {
                                        window.location.reload();
                                    }
                                );
                            }
                        },
                        error: function ($resp) {
                            var $respErrors = $.parseJSON($resp.responseText);

                            let error = '';
                            if ($respErrors.errors) {
                                let errors = $respErrors.errors;
                                error = errors[Object.keys(errors)[0]];
                            }
                            $this.showErrorModule(error);
                        }
                    });
                }
            });
        },
        showGeneralModule: function showGeneralModule(html, onCloseCallback) {
            if (!html) {
                html = '';
            }
            if (!onCloseCallback) {
                onCloseCallback = function () {
                };
            }

            $('#generalModal').find('.modal-body').html(html);
            $('#generalModal').modal('show');
            $('#generalModal').on('hide.bs.modal', onCloseCallback);
        },
        showErrorModule: function showErrorModule(text, onCloseCallback) {
            if (!text) {
                text = 'Unknown error';
            }
            if (!onCloseCallback) {
                onCloseCallback = function () {
                };
            }

            $('#errorModal').find('.modal-body').find('.error-container').html(text);
            $('#errorModal').modal('show');
            $('#errorModal').on('hide.bs.modal', onCloseCallback);
        }
    },
    watch: {
        productId: function (productId) {
            // console.log('productId:' + productId);
        }
    }
});
